import { BaseVue, Component, Prop, Watch } from '@newview/base-web';
import { PropertySchema, ValueType } from "./PropertySchema";
import "./PropertyEdit.less";
@Component({
    components: {}
})
export default class PropertyEdit extends BaseVue {

    @Prop() itemSchema?: PropertySchema 
    changeNumber: number = 0; 
    @Prop({ default: "" })  value: any; 
    editValue: any = ""; 
    @Watch('value', { deep: false })

    valueChange(item, oldValue) {
        this.changeNumber = this.changeNumber + 1;
        this.editValue = item;
    } 
    @Watch("itemSchema", { deep: true })
    itemSchemaChange(item: PropertySchema, oldValue: PropertySchema) {
        this.changeNumber = this.changeNumber + 1;
        if (item.isEdit == true) {
            this.$nextTick(() => {
                const editControl = this.ref('editControl');
                if (editControl && editControl.focus) {
                    editControl.focus();
                }
            });
        }
    }  
    onChange() {
        this.$emit('input', this.editValue);
    } 
    created() {
        this.editValue = this.value;
    } 
    mounted() { } 
    setEditValue(value) { 
        switch (this.itemSchema!.valueType) {
            case ValueType.boolean:
                this.editValue = value == 'true' || value == '1' || value == 1;
                break;
            case ValueType.float:
                this.editValue = parseFloat(value);
                break;
            case ValueType.number:
                this.editValue = parseInt(value);
                break;
            default:
                this.editValue = value;
                break;
        } 
        this.$emit('input', this.editValue);
    }

    renderInput(h) {
        const options = Object.assign({
            props: {
                placeholder: '请输入属性值...',
                value: this.isNull(this.editValue) ? '' : `${this.editValue}`
            },
            ref: 'editControl',
            on: {
                input: (value) => {
                    if(value.toString().indexOf('%')!=-1){
                        if(parseInt(value.toString().replace(/%/g,''))>100){
                            value='100%';
                        }
                    }
                    this.setEditValue(value);
                },
                'on-blur': () => {
                    this.$emit('change', this.editValue);
                }
            }
        }, this.itemSchema!.editOption);
        return h('Input', options);
    } 
    renderSelect(h) {
        const sels: any[] = [];
        const datas = this.itemSchema!.datas!;
        datas.forEach(function (selItem, index) {
            sels.push(
                h(
                    "Option",
                    { props: { value: `${selItem.value}` } },
                    selItem.text
                )
            );
        }); 
        const options = Object.assign({
            props: {
                value: `${this.editValue}`,
            },
            ref: 'editControl',
            on: {
                input: (value) => {
                    this.setEditValue(value);
                },
                'on-change': () => {
                    this.$emit('change', this.editValue);
                }
            }
        }, this.itemSchema!.editOption);

        return h("Select", options, sels);
    }
    renderColor(h){
        return h("ColorPicker", {
            props: { 
                value: this.isNull(this.editValue) ? this.editValue.defaultValue : `${this.editValue}`,
                alpha:true
            },
            ref: 'editControl',
            on: {
                input: (value) => {
                    this.setEditValue(value);
                },
                'on-change': () => {
                    this.$emit('change', this.editValue);
                }
            }
        });
    }
    renderButton(h) {
        return h('Button', {
            props: { type: "success", size: "small" },
            style: { fontSize: '12px', height: '22px' },
            on: {
                click: () => {
                    if (this.itemSchema!.onButtonClick) {
                        this.itemSchema!.onButtonClick();
                    }
                }
            }
        }, this.itemSchema!.buttonText!)
    } 
    renderEdit(h) {
        let editDom;

        switch (this.itemSchema!.type) {
            case 'Input':
                editDom = this.renderInput(h);
                break;
            case 'Select':
                editDom = this.renderSelect(h);
                break;
            case 'Color':
                editDom = this.renderColor(h)
                break;
            case 'Button':
                editDom = this.renderButton(h)
                break;
        }

        return h('div', { style: this.itemSchema!.isEdit == true ? 'display: block' : 'display: none' }, [editDom]);
    }

    renderView(h) { 
        let value = this.value; 
        switch (this.itemSchema!.type) {
            case 'Input':{ 
                break;
            } 
            case 'Select':{
                const datas = this.itemSchema!.datas!; 
                value = datas.filter(item => item.value == value)[0].text;
                break;
            } 
           case 'Color':{ 
                break;
           }                
           case 'Button':{
            value = [this.renderButton(h)]
            break;
           } 
        } 
        return h('div', { style: this.itemSchema!.isEdit != true ? 'display: block' : 'display: none' }, value);
    }

    render(h) { 
        return h('div', { class: 'propertyEdit' }, [this.renderView(h), this.renderEdit(h)])
      // if (this.config!.isEdit == true) {
        //     return this.renderEdit(h);
        // } else {
        //     return this.renderView(h);
        // }

    }
}